import React, {useMemo} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {chatActions} from '_actions';
import {getDateObject} from "../../../Utility/dateUtils";
import { dateActions } from '_actions';

const DateContainer = styled.div`
  margin: 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 8px; 
  text-align: center;
  outline: none;
  box-sizing: border-box;

  border: 2.5px solid  ${(props) =>
          props.isHoliday ? props.theme.themeColors[props.theme.activeTheme].quicklinksBorderHolidayColor
                  : props.theme.themeColors[props.theme.activeTheme].quicklinksBorderColor
  };
  border: 1px solid ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageBorderColor};
  box-shadow: 0px 0px 6px 0px rgba(180, 180, 180, 0.25);


  &:focus-visible {
    outline: none;
    box-shadow: 0 0 2px 2px ${(props) => props.theme.themeColors[props.theme.activeTheme].focusColor};
  }

  ${({isHoliday}) => !isHoliday ? `cursor: pointer;` : `cursor: not-allowed;`};


  width: 88px;
  height: 83px;
  padding-top: 7px;
  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 124px;
    height: 124px;
  }

  .weekday {
    font-family: Plus Jakarta Sans;
    font-weight: 500;
    color:${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
  }

  .month {
    font-family: Plus Jakarta Sans;
    font-weight: 500;
    color:${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
  }

  .weekday {
    margin-bottom: 2px;
    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
      margin-bottom: 2px;
    }

    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
      margin-bottom: 10px;
    }
  }

  .day {
    margin-top: 8px;
    margin-bottom: 8px;

    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) { 
    margin-top: 0px;
    margin-bottom: 2px;
    }

    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {  
    margin-top: 0px;
    margin-bottom: 8px;
    }
  }

  .month,
  .weekday {
    font-size: 10px;
    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
      font-size: 16px;
      line-height: 14px;
    }
  }

  .day {
    font-family: DM Sans;
    font-size: 25px;
    line-height: 0.5;
    color: ${(props) =>
            props.isHoliday ? props.theme.themeColors[props.theme.activeTheme].quicklinksDayHolidayColor
                    : props.theme.themeColors[props.theme.activeTheme].quicklinksDayColor
    };

    color:${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinkImageText};
    font-size: 25px;
    font-weight: 600;

    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
      line-height: 1;
    }

    @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
      font-size: 38px;
      line-height: 34px;
    }
  }

  :hover > .day,
  :hover > .hour,
  :hover > .period {
    ${(props) => props.isHoliday && `
      color: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinksBorderColor};
    `}
  }


  .hour,
  .period {
    color: ${(props) => props.theme.themeColors[props.theme.activeTheme].quicklinksDayColor};
  }

  .hour {
    font-family: Lato;
    font-weight: bold;
    font-size: 20px;
    line-height: 1;

    @media screen and (max-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
      font-size: 18px;
    }
  }

  .period {
    font-family: DM Sans;
    font-weight: 600;
    font-size: 12px;

    @media screen and (max-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
      font-size: 14px;
    }
  }

  &:hover {
    background: #FBFBFB;
    border:none;
    box-shadow: 0px 0px 10px 0px rgba(122, 122, 122, 0.25);

    .day {
      color: ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
    }

    .hour {
      color: #42accd;
    }

  }

  .cap-image {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  &.active-date {
    width: 105px;
    height: 100px;
    .day {
      color: ${(props) => props.theme.themeColors[props.theme.activeTheme].main};
    }
  }

  &.time-container {
    width: 70px;
    height: 80px;

    @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) { 
        width: 90px;
        height: 100px;
      }

  }

  
  @media screen and (min-width: ${(props) =>
    props.theme.screenSizes.breakLaptop}) {
      .cap-image {
        width: 100%;
      }   
      &.active-date {
        width: 135px;
        height: 135px;
      }
    }

    .move-in-month, .move-in-weekday {
      font-size: 13px;
    }
`;

function DateTime({data, send, isHoliday, language,activeDate, sendDate,active}) {
  let customeMoveIn = data.subType === 'custom-move-in';
  let isFinalDate = data.value.includes(" ") || data.value.includes("T");
  let format = data.text.includes("AM") || data.text.includes("PM") ? 'time' : 'date';
  if(data.subType !== 'text'){
    format = data.subType;
  }

  const sendDateData = () => {
      let sendData = {
        ...data
      }
      if(activeDate) {
        sendData.text = activeDate + " " + sendData.text;
      }
      send(sendData)
  }


  const handleKeyPress = (e) => {
    if (!isHoliday && !isFinalDate && !customeMoveIn  && (e.key === 'Enter' || e.key === ' ')) {
      sendDate(data);
    }else {
      sendDateData();
    }
  };


  const time = format === 'time' && data.text.split(" ");
  const locale = useMemo(() => language === "English" ? "en" : "es", [language]);
  const date = useMemo(() => getDateObject(data.value, locale), [locale]);
  return (
    <DateContainer
      className={`${active && 'active-date'} ${format === 'time' && 'time-container'}`}
      tabIndex={0}
      onKeyPress={handleKeyPress}
      onClick={() => !isHoliday && !isFinalDate && !customeMoveIn ? sendDate(data) : sendDateData()}
      isHoliday={isHoliday}
    >

      {format === "date" && active && !customeMoveIn && <img className="cap-image" src={process.env.PUBLIC_URL + '/images/light-mode/date-cap.svg'} alt='date-cap'/>}
      {customeMoveIn && <img className="cap-image custome" src={process.env.PUBLIC_URL + '/images/light-mode/date-cap.svg'} alt='date-cap'/>}
      {format === 'time' && (
        <>
          <span className="hour">{time[0]}</span>
          <span className="period">{time[1]}</span>
        </>
      )}
      {
        format === 'date' && (
          <>
            <span className="weekday">{date.weekday}</span>
            <span className="day">{date.day}</span>
            <span className="month">{date.month}</span>
          </>
        )
      }
      {
        format === 'custom-move-in' && (
          <>
            <span className="weekday move-in-weekday">{date.month}</span>
            <span className="month move-in-month">{date.year}</span>
          </>
        )
      }
    </DateContainer>
  );
}

const mapStateToProps = (state) => ({
  activeDate: state.date.activeDate,
  language: state.settings.language,
})

const actions = {
  send: chatActions.send,
  sendDate: dateActions.sendDate
};

export default connect(mapStateToProps, actions)(DateTime);